import { DisputeDetailsDto } from "@admin_api/models/dispute-details-dto";

export class DisputeState {
    loading = false;
    error = null;
    record: DisputeDetailsDto = null;
}
